import React, { useState } from "react";
import { useSelector } from "react-redux";
import Datatable from "../components/Datatable";
import Filters from "../components/Filters";
import { Box } from "@mui/material";
import "../components/TimePeriodVisualization";
import { PROGRAMS, STATES } from "../services/util";

const DatatablePage = () => {
  const data = useSelector(state => state.data);
  const [filters, setFilters] = useState({
    State: [],
    Program: [],
    Month: [],
  });

  const filterOptions = {
    Program: [...new Set(PROGRAMS.map(program => program.label))],
    State: [...new Set(STATES.map(state => state.name))],
    Month: [...new Set(data.map(item => new Date(item.Month).toLocaleDateString(undefined, { year: "numeric", month: "short" })))],
  };

  return (
    <div>
      <Box>
        <Box className="visualization-description">
          <p className="headline-title">The Complete STAR Dataset</p>
          <p className="headline-body">
            This table contains all available CRP and DP data collected from November 2023 - onward.
          </p>
        </Box>
        <Box className="visualization-border">
        <p className="headline-title">Filters</p>
        <Filters filters={filters} setFilters={setFilters} filterOptions={filterOptions} />
        </Box>
        <Datatable data={data} filters={filters} />
      </Box>
    </div>
  );
};

export default DatatablePage;
